import type { SelectFieldOption } from '@/components/inputs/CustomSelectField'

export function sortOptionsAlphabetically<V>(options: SelectFieldOption<V>[]) {
  return options.sort((a, b) => a.label.localeCompare(b.label))
}
